"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BusinessLevel = _interopRequireDefault(require("./BusinessLevel"));
var _Customer = _interopRequireDefault(require("./Customer"));
var _Employee = _interopRequireDefault(require("./Employee"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Business model module.
 * @module model/Business
 * @version 3.0
 */
var Business = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Business</code>.
   * @alias module:model/Business
   */
  function Business() {
    _classCallCheck(this, Business);
    Business.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Business, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Business</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Business} obj Optional instance to populate.
     * @return {module:model/Business} The populated <code>Business</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Business();
        if (data.hasOwnProperty('organizationId')) {
          obj['organizationId'] = _ApiClient["default"].convertToType(data['organizationId'], 'Number');
        }
        if (data.hasOwnProperty('organizationLegacyId')) {
          obj['organizationLegacyId'] = _ApiClient["default"].convertToType(data['organizationLegacyId'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('businessCode')) {
          obj['businessCode'] = _ApiClient["default"].convertToType(data['businessCode'], 'String');
        }
        if (data.hasOwnProperty('employees')) {
          obj['employees'] = _ApiClient["default"].convertToType(data['employees'], [_Employee["default"]]);
        }
        if (data.hasOwnProperty('managedCustomers')) {
          obj['managedCustomers'] = _ApiClient["default"].convertToType(data['managedCustomers'], [_Customer["default"]]);
        }
        if (data.hasOwnProperty('levels')) {
          obj['levels'] = _ApiClient["default"].convertToType(data['levels'], [_BusinessLevel["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Business</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Business</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['organizationLegacyId'] && !(typeof data['organizationLegacyId'] === 'string' || data['organizationLegacyId'] instanceof String)) {
        throw new Error("Expected the field `organizationLegacyId` to be a primitive type in the JSON string but got " + data['organizationLegacyId']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['businessCode'] && !(typeof data['businessCode'] === 'string' || data['businessCode'] instanceof String)) {
        throw new Error("Expected the field `businessCode` to be a primitive type in the JSON string but got " + data['businessCode']);
      }
      if (data['employees']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['employees'])) {
          throw new Error("Expected the field `employees` to be an array in the JSON data but got " + data['employees']);
        }
        // validate the optional field `employees` (array)
        var _iterator = _createForOfIteratorHelper(data['employees']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _Employee["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['managedCustomers']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['managedCustomers'])) {
          throw new Error("Expected the field `managedCustomers` to be an array in the JSON data but got " + data['managedCustomers']);
        }
        // validate the optional field `managedCustomers` (array)
        var _iterator2 = _createForOfIteratorHelper(data['managedCustomers']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _Customer["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      if (data['levels']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['levels'])) {
          throw new Error("Expected the field `levels` to be an array in the JSON data but got " + data['levels']);
        }
        // validate the optional field `levels` (array)
        var _iterator3 = _createForOfIteratorHelper(data['levels']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item2 = _step3.value;
            _BusinessLevel["default"].validateJSON(_item2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} organizationId
 */
Business.prototype['organizationId'] = undefined;

/**
 * @member {String} organizationLegacyId
 */
Business.prototype['organizationLegacyId'] = undefined;

/**
 * @member {String} description
 */
Business.prototype['description'] = undefined;

/**
 * @member {String} businessCode
 */
Business.prototype['businessCode'] = undefined;

/**
 * @member {Array.<module:model/Employee>} employees
 */
Business.prototype['employees'] = undefined;

/**
 * @member {Array.<module:model/Customer>} managedCustomers
 */
Business.prototype['managedCustomers'] = undefined;

/**
 * @member {Array.<module:model/BusinessLevel>} levels
 */
Business.prototype['levels'] = undefined;
var _default = exports["default"] = Business;